import React from "react"
import { Affix as AntdAffix } from "antd"
import type { AffixProps } from "antd/lib/affix"

export const Affix = (props: AffixProps): JSX.Element => {
  return <AntdAffix {...props} />
}
